import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useProject } from 'querys/projects'
import { P } from 'common/typography'

const DownloadProgresStyled = styled.div`
  margin-top: 4px;
  color: var(--neutralBase);
  span {
    font-weight: 600;
  }
  .color {
    color: var(--secondary)};
  }
  .figma-url {
    color: var(--neutralBase);
    margin-bottom: 24px;
  }
  .dontgiveup {
    font-weight: 600;
  }
`

function DownloadProgress({ loading }) {
  const {
    data: {
      slug,
    },
  } = useProject()
  return (
    <DownloadProgresStyled>
      <div className="progress-info figma-url">
        {loading ? (
          <P id={`figma-${slug}`}>
            Descargando proyecto....
          </P>
        ) : (
          <P id="figma-downloaded">
            Ya has descargado este proyecto
          </P>
        )}
      </div>
      <div className="progress-info dontgiveup">
        ¡No Te Rindas!
      </div>
    </DownloadProgresStyled>
  )
}

DownloadProgress.propTypes = {
  loading: PropTypes.bool.isRequired,
}

export default DownloadProgress
